var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-container"},[_c('user-header'),_c('div',{staticClass:"user-main"},[_c('user-side'),_c('router-view')],1),(_vm.LOADING)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }